// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { ApplicationUser } from './application-user';
import { PurchaseTransaction } from './purchase-transaction';
import { SalesTransaction } from './sales-transaction';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class TransactionType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  transactionTypeId: number;
  applicationUserId: string;
  name: string;
  applicationUser: ApplicationUser;
  purchaseTransactions: PurchaseTransaction[];
  salesTransactions: SalesTransaction[];
}

